var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center pointer"},[_c('e-svg-icon',_vm._b({},'e-svg-icon',_vm.icon.attrs,false),[_vm._v(_vm._s(_vm.icon.name))]),_c('span',{class:_vm.textClass},[_vm._v(_vm._s(_vm.value))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }